<template>
    <span class="comment-counter" v-if="count && !isGuest">{{ count }}</span>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
    props: {
        count: Number
    },
    computed: {
        ...mapGetters("User", ["isGuest"]),
    },
};
</script>

<style lang="scss" scoped>
.comment-counter {
    font-size: 0.7rem;
    //line-height: 1;
    font-weight: bold;
    min-width: 14px;
    text-align: center;
    background: var(--color-bg-dark);
    border-radius: 5px;
    border: 1px solid var(--font-default-color);
    color: var(--font-default-color);
    padding: 3px 4px;
    //margin-right: 7px;
    position: absolute;
    right: 130%;
    //opacity: 0.4;
    //transform: translateX(-125%);
}
</style>
